import React, { useRef } from 'react';

export const DocumentUploadField = ({ value, onChange, isReadOnly = false, error }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      onChange(file);
    }
  };

  const triggerUpload = () => {
    if (!isReadOnly && fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="relative">
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="hidden"
        accept="image/*,application/pdf"
      />
      
      {value ? (
        <div className="flex items-center justify-between h-11 px-4 bg-[var(--color-primary)]/5 border border-[var(--color-primary)]/20 rounded-xl overflow-hidden">
          <span className="text-[11px] font-bold text-[var(--color-primary)] truncate max-w-[120px]">
            {typeof value === 'string' ? 'View Document' : value.name}
          </span>
          {!isReadOnly && (
            <button
              onClick={() => onChange(null)}
              className="text-[var(--color-error)] hover:scale-110 transition-transform"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      ) : (
        <button
          onClick={triggerUpload}
          disabled={isReadOnly}
          className={`w-full h-11 px-4 flex items-center justify-center gap-2 rounded-xl border-2 border-dashed transition-all ${
            error 
              ? 'border-[var(--color-error)]/40 bg-[var(--color-error)]/5 text-[var(--color-error)]' 
              : 'border-[var(--color-border)] hover:border-[var(--color-primary)]/40 hover:bg-[var(--color-primary)]/5 text-[var(--color-text-secondary)]'
          }`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
          </svg>
          <span className="text-[12px] font-bold uppercase tracking-wider">Upload</span>
        </button>
      )}
      {error && <span className="absolute -bottom-4 left-1 text-[9px] font-bold text-[var(--color-error)] uppercase">{error}</span>}
    </div>
  );
};
